import { render, staticRenderFns } from "./builder-pizza.vue?vue&type=template&id=13fb1519&scoped=true&lang=pug"
import script from "./builder-pizza.vue?vue&type=script&lang=coffee"
export * from "./builder-pizza.vue?vue&type=script&lang=coffee"
import style0 from "./builder-pizza.vue?vue&type=style&index=0&id=13fb1519&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fb1519",
  null
  
)

export default component.exports